import React from "react";
import { useEffect } from "react";
import Header from "./guideheader";
import GuidePopup from "@/components/atomics/guidePopup";
import Button from "@/components/atomics/button";
import { FaLeaf } from "react-icons/fa";

interface FirstGuideProps {
  subTitle: string;
  popupTitle: string;
  className?: string;
  title: string;
  content: string;
  cancelClick: () => void;
  guideClick: () => void;
}

const FirstGuide = ({
  title,
  popupTitle,
  subTitle,
  content,
  className,
  cancelClick,
  guideClick,
}: FirstGuideProps) => {
  return (
    <div className={`${className}  flex flex-col`}>
      <Header title={title} onCancelClick={cancelClick} />
      <div className="px-[30px] pb-[50px] sl:px-[40px] min-h-[515px]">
        <GuidePopup title={popupTitle} className={"mt-[30px]"} />
        <div className=" font-spline-sans-mono text-lg sl:text-xl">
          <p className="" dangerouslySetInnerHTML={{ __html: subTitle }} />
        </div>
        <Button
          className="w-full mt-[29px] custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
          image="/assets/button.svg"
          text="GUIDE"
          onClick={guideClick}
        />
      </div>
    </div>
  );
};

export default FirstGuide;
